// Ad-slot placeholder. Reserved space ready for a gambling-tolerant ad network.
export const AdSlot = ({ size = "728x90", label = "Leaderboard", className = "", sticky = false }) => {
  return (
    <div
      data-testid={`ad-slot-${size}`}
      data-ad-size={size}
      className={`relative flex flex-col items-center justify-center border border-dashed border-white/20 bg-white/[0.015] text-center px-4 py-6 ${
        sticky ? "sticky top-20" : ""
      } ${className}`}
      style={{ minHeight: size === "728x90" ? 90 : size === "300x600" ? 320 : 100 }}
    >
      <span className="overline text-white/30">Advertisement</span>
      <span className="font-mono text-xs text-white/25 mt-1.5">
        AD SLOT · {size} · {label}
      </span>
    </div>
  );
};
